import React, { useState, useEffect, useContext } from 'react'
import { useParams, useNavigate } from 'react-router-dom'
import Sidedash from '../uicomponents/Sidedash'
import AlertContext from '../../context/AlertContext'
import SeatContext from '../../context/SeatContext'

const EditSeat = () => {
  const { id } = useParams()
  const navigate = useNavigate()
  const { showAlert } = useContext(AlertContext)
  const { seats, getAllSeats, editSeat, deleteSeat } = useContext(SeatContext)

  const [formData, setFormData] = useState({ seatNumber: '', seatLocation: '' })

  // Ensure seats are loaded
  useEffect(() => {
    if (seats.length === 0) {
      getAllSeats()
    }
  }, [getAllSeats, seats.length])

  // Populate form when seats data is available
  useEffect(() => {
    const seat = seats.find(s => s._id === id)
    if (seat) {
      setFormData({ seatNumber: seat.seatNumber, seatLocation: seat.seatLocation })
    } else if (seats.length > 0) {
      showAlert('Seat not found', 'warning')
      navigate('/allseats')
    }
  }, [seats, id, navigate, showAlert])

  const handleChange = (e) => {
    const { name, value } = e.target
    setFormData(prev => ({ ...prev, [name]: value }))
  }

  const handleSubmit = async (e) => {
    e.preventDefault()
    const seatNum = parseInt(formData.seatNumber, 10)
    const result = await editSeat(id, seatNum, formData.seatLocation)
    if (result.success) {
      showAlert('Seat updated successfully', 'success')
      navigate('/allseats')
    } else {
      showAlert(`Error updating seat: ${result.message}`, 'danger')
    }
  }

  const handleDelete = async () => {
    if (window.confirm('Are you sure you want to delete this seat? This action cannot be undone.')) {
      const result = await deleteSeat(id)
      if (result.success) {
        showAlert('Seat deleted successfully', 'success')
        navigate('/allseats')
      } else {
        showAlert(`Error deleting seat: ${result.message}`, 'danger')
      }
    }
  }

  return (
    <div className="container-fluid">
      <div className="row">
        <Sidedash />
        <div className="col-md-9 pt-3">
          <h2>Edit Seat</h2>
          <form onSubmit={handleSubmit}>
            <div className="mb-3">
              <label htmlFor="seatNumber" className="form-label">Seat Number</label>
              <input
                type="number"
                className="form-control"
                id="seatNumber"
                name="seatNumber"
                value={formData.seatNumber}
                onChange={handleChange}
                required
              />
            </div>
            <div className="mb-3">
              <label htmlFor="seatLocation" className="form-label">Seat Location</label>
              <input
                type="text"
                className="form-control"
                id="seatLocation"
                name="seatLocation"
                value={formData.seatLocation}
                onChange={handleChange}
                required
              />
            </div>
            <div className="d-flex">
              <button type="submit" className="btn btn-primary me-2">Update Seat</button>
              <button type="button" className="btn btn-danger" onClick={handleDelete}>Delete Seat</button>
            </div>
          </form>
        </div>
      </div>
    </div>
  )
}

export default EditSeat 